<template>
  <div class="mod_column_flex mod_align_item_center pay_success_container">
    <img src="../../assets/icon_pay_success.png" style="width: 80px;height: 80px;margin-top: 80px"/>
    <p class="pay_success_text">支付成功</p>
    <van-button plain type="primary" style="width: 144px;height: 40px;border-radius: 8px;margin-top: 48px" @click="close">完成</van-button>
  </div>
</template>

<script>
export default {
  name: "PaySuccess",
  methods:{
    close(){
      // eslint-disable-next-line no-undef
      AlipayJSBridge.call('closeWebview');
    }
  }
}
</script>

<style scoped lang="less">
.pay_success_container{
  background: white;
  height: 100vh;
  .pay_success_text{
    font-weight: 500;
    font-size: 17px;
    color: #262626;
    text-align: center;
    line-height: 24px;
    margin-top: 16px;
  }
}

</style>
